<template>
    <div class="login-page-wrapper contact-us-form" :class="{'bodyfont-unauth': !user}">
        <div class="over-lay"></div>
        <transition name="bounce">
        <div class="container">
            <!--<alert v-model="success" placement="top-right" duration="2000" type="success" width="400px" dismissable>-->
                <!--<span class="icon-info-circled alert-icon-float-left"></span>-->
                <!--<strong>Sent!</strong>-->
                <!--<p id="contactus_successmsg">{{successMsg}}</p>-->
            <!--</alert>-->
            <div class="row">
                <div class="col-md-12">
                    <div class="main-content">
                        <h2 v-bind:style="{ color: getCorpHeadingColor } ">Want to become a TONE Expert?</h2>
                        <p style="text-align: center">TONE is a platform for women helping women in all areas of life. We look for experts in fields that can help
                            women grow professionally and personally to live life to the fullest potential. Our experts are highly
                            credentialed, successful in their fields and passionate about helping women. TONE underwrites production and
                            related expenses, and experts are not paid a fee for their appearances. Please complete this form and tell us
                            about yourself and why you would be a great addition to TONE</p>
                    </div>
                </div>
                <div class="contact-form">
                    <div class="form">
                        <form id="contactus_form" v-on:submit.prevent="onSubmit">
                            <div>
                                <bs-input v-model="becomeExpert.firstName"
                                          type="text"
                                          class="form-input"
                                          error="First Name"
                                          placeholder="First Name"
                                          required
                                          >
                                </bs-input>
                                <bs-input v-model="becomeExpert.lastName"
                                          type="text"
                                          class="form-input"
                                          error="Last Name"
                                          placeholder="Last Name"
                                          required
                                >
                                </bs-input>
                                <bs-input v-model="becomeExpert.email"
                                          id="contactus_email"
                                          type="email"
                                          class="form-input"
                                          error="Email Address"
                                          placeholder="Email Address"
                                          required
                                >
                                </bs-input>
                                <div class="form-group">
                                <masked-input v-model="becomeExpert.phone"
                                          id="contactus_phonenumber"
                                          class="form-control"
                                          error="Phone Number"
                                          placeholder="Phone Number"
                                              mask="\(111) 111-1111"
                                              required
                                          >
                                </masked-input>
                                </div>
                                <bs-input v-model="becomeExpert.reachMethod"
                                          type="text"
                                          class="form-input"
                                          error="Reach Method"
                                          placeholder="Preferred method to Reach to you"
                                          required
                                >
                                </bs-input>
                                <bs-input v-model="becomeExpert.websiteUrl"
                                          type="text"
                                          class="form-input"
                                          error="Website"
                                          placeholder="Website URL"
                                          required
                                >
                                </bs-input>
                                <bs-input v-model="becomeExpert.smFacebook"
                                          type="text"
                                          class="form-input"
                                          error="Facebook"
                                          placeholder="Facebook"
                                >
                                </bs-input>
                                <bs-input v-model="becomeExpert.smInstagram"
                                          type="text"
                                          class="form-input"
                                          error="Instagram"
                                          placeholder="Instagram"
                                >
                                </bs-input>
                                <bs-input v-model="becomeExpert.smTwitter"
                                          type="text"
                                          class="form-input"
                                          error="Twitter"
                                          placeholder="Twitter"
                                >
                                </bs-input>
                                <bs-input v-model="becomeExpert.smLinked_in"
                                          type="text"
                                          class="form-input"
                                          error="LinkedIn"
                                          placeholder="LinkedIn"
                                >
                                </bs-input>
                                <bs-input v-model="becomeExpert.smPinterest"
                                          type="text"
                                          class="form-input"
                                          error="Pinterest"
                                          placeholder="Pinterest"
                                >
                                </bs-input>
                                <bs-input v-model="becomeExpert.smOther"
                                          type="text"
                                          class="form-input"
                                          error="Other"
                                          placeholder="Other"
                                >
                                </bs-input>
                                <bs-input v-model="becomeExpert.howHearTone"
                                          type="text"
                                          class="form-input"
                                          error="Other"
                                          placeholder="How did you hear about TONE?"
                                >
                                </bs-input>
                                <div class="checkbox text-left"><label>
                                    <input type="checkbox"  class="checkbox form-input" v-model="becomeExpert.toneMember">
                                    Are you currently a TONE Member?
                                </label></div>
                                <bs-input v-model="becomeExpert.bioProfExp"
                                          type="textarea"
                                          class="form-input"
                                          error="Professional Biography"
                                          placeholder="Provide an overview of your professional experience and your bio"
                                          required
                                          >
                                </bs-input>
                                <bs-input v-model="becomeExpert.otherPersonalInfo"
                                          type="textarea"
                                          class="form-input"
                                          error="Comments"
                                          placeholder="Other info about you (e.g. speaking experiences, links to relevant material, publications, etc.)"
                                >
                                </bs-input>
                                <bs-input v-model="becomeExpert.joinReason"
                                          type="textarea"
                                          class="form-input"
                                          error="Join Reason"
                                          placeholder="Tell us why you’d like to be a part of TONE"
                                          required
                                >
                                </bs-input>
                                <bs-input v-model="becomeExpert.videoTopic"
                                          type="textarea"
                                          class="form-input"
                                          error="Video Topics"
                                          placeholder="What topics would you propose for your TONE videos?"
                                          required
                                >
                                </bs-input>
                                <div class="form-control" style="height: auto;text-align: left; margin: 0 0 30px;">
                                    Which content areas would your videos appear in? (check all that apply)
                                <div class="checkbox">
                                    <label >
                                        <input type="checkbox" class="form-input" v-model="becomeExpert.contentWork"> Work
                                    </label>
                                </div>
                                <div class="checkbox">
                                    <label >
                                <input type="checkbox" class="form-input" v-model="becomeExpert.contentLife"> Life
                                    </label>
                                </div>
                                <div class="checkbox">
                                    <label >
                                <input type="checkbox" class="form-input" v-model="becomeExpert.contentMind"> Mind/Body
                                    </label>
                                </div>
                                <div class="checkbox">
                                    <label >
                                <input type="checkbox" class="form-input" v-model="becomeExpert.contentMoney"> Money
                                    </label>
                                </div>
                                </div>
                            </div>
                            <div>
                                <button v-if="!spinner" class="btn formButton btn-transparent" id="contact_sendbutton" v-bind:style="{ color: getCorpButtonColor, borderWidth: '1px !important', borderStyle: 'solid !important', borderColor: this.getCorpButtonColor + ' !important'}">
                                    Send Request
                                    <spinner v-if="spinner" v-model="spinner" size="lg" class="btn-spinner"></spinner>
                                </button>
                            </div>
                        </form>
                        <alert v-model="error.show" placement="top-right" duration="2000" type="danger" width="400px" dismissable>
                            <span class="icon-info-circled alert-icon-float-left"></span>
                            <strong>Error:</strong>
                            <p id="contactus_errormsg">{{error.message}}</p>
                        </alert>
                    </div>
                </div>
                <!--<div class="contactformtexttone contact-form">-->
                    <!--<h3>Want to become a TONE Expert?</h3>-->

                       <!--<p>-->
                           <!--TONE is a platform for women helping women in all areas of life. We look for experts in fields that can help women grow professionally and personally to live life to the fullest potential. Our experts are highly credentialed, successful in their fields and passionate about helping women. TONE underwrites production and related expenses, and experts are not paid a fee for their appearances. Please complete this form and tell us about yourself and why you would be a great addition to TONE.-->
                       <!--</p>-->
                        <!--<p>-->
                            <!--Fully completed forms should be sent to <a href="mailto:experts@tonenetworks.com"> experts@tonenetworks.com</a>-->
                        <!--</p>-->
                    <!--<p><a href="https://s3.amazonaws.com/assets.tonenetworks.com/resources/Become_Expert_Form.pdf" class="pinklinkcontectext" donwload="Become_Expert_Form.pdf" target="_blank"> Become a Tone Expert (PDF)</a></p>-->
                <!--</div>-->
            </div>
        </div>
        </transition>
    </div>
</template>

<script>
    import { input, spinner, alert } from 'vue-strap'
    import { mapGetters } from 'vuex'
    import MaskedInput from 'vue-masked-input'

    export default {
        components: {
            'bs-input': input,
            'spinner': spinner,
            'alert': alert,
            'masked-input': MaskedInput
        },
        name: 'login',
        metaInfo () {
            return {
                title: 'TONE | Contact Us',
                meta: [
                    {property: 'og:image', content: 'https://s3.amazonaws.com/assets.tonenetworks.com/images/slide-1.jpg'},
                    {property: 'og:title', content: 'TONE | Become an Expert'},
                    {property: 'og:site_name', content: 'TONE Networks | Expert Advice on Demand'},
                    {
                        property: 'og:description',
                        content: 'TONE Networks provides women with resources and support to help them flourish in every aspect of their lives.'
                    },
                    {property: 'twitter:title', content: 'TONE | Become an Expert'},
                    {property: 'twitter:card', content: 'summary'},
                    {property: 'twitter:image', content: 'https://s3.amazonaws.com/assets.tonenetworks.com/images/slide-1.jpg'},
                    {
                        property: 'twitter:description',
                        content: 'TONE Networks provides women with resources and support to help them flourish in every aspect of their lives.'
                    },
                    {property: 'og:image:width', content: '300'},
                    {property: 'og:image:height', content: '300'}
                ]
            }
        },
        data: function () {
            return {
                success: false,
                successMsg: '',
                becomeExpert: {
                    firstName: '',
                    lastName: '',
                    email: '',
                    phone: '',
                    reachMethod: '',
                    websiteUrl: '',
                    smFacebook: '',
                    smInstagram: '',
                    smTwitter: '',
                    smLinked_in: '',
                    smPinterest: '',
                    smOther: '',
                    howHearTone: '',
                    toneMember: false,
                    bioProfExp: '',
                    otherPersonalInfo: '',
                    joinReason: '',
                    videoTopic: null,
                    contentWork: false,
                    contentLife: false,
                    contentMind: false,
                    contentMoney: false
                },
                spinner: false
            }
        },
        computed: {
            ...mapGetters([
                'error', 'user', 'getCorpHeaderColor', 'getCorpFooterColor', 'getCorpButtonColor', 'getCorpHeadingColor'
            ])
        },
        methods: {
            spinnerToggle () {
                this.spinner = !this.spinner
            },
            onSubmit () {
                if (this.becomeExpert.email) {
                    this.spinnerToggle()
                    this.$store.dispatch('BECOME_EXPERT_REQUEST', this.becomeExpert).then(() => {
//                        this.success = true
//                        this.successMsg = 'Your message has been sent, we will get back to you shortly!'
                        this.spinnerToggle()
                        this.$swal({
                            title: 'Request Sent!',
                            text: 'We will get back to your shortly',
                            type: 'success',
                            timer: 3000,
                            showCancelButton: false,
                            showConfirmButton: false
                        }).then(
                            function () {
                            },
                            // handling the promise rejection
                            function (dismiss) {
                                if (dismiss === 'timer') {
                                }
                            }
                        )
                    })
                }
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .bounce-enter-active {
        animation: bounce-in .5s;
    }
    .bounce-leave-active {
    animation: bounce-in .1s reverse;
    }
    @keyframes bounce-in {
        0% {
            transform: scale(0);
        }
        50% {
            transform: scale(1.5);
        }
        100% {
            transform: scale(1);
        }
    }
#contactus_phone {
    padding: 0 30px 0 15px;
    height: 60px;
    margin-bottom: 20px;
}
.contact-us-form p {
    font-size: 22px;
    font-family: sans-serif;
    letter-spacing: 0.5px;
    margin: 0 0 30px 0;
    font-weight: normal;
    line-height: 1;
    color: #777777;
}
.contact-us-form h2 {
    color: #f0617d;
    text-transform: capitalize;
    margin: 40px 0 15px 0;
    letter-spacing: 0.5px;
    font-family: sans-serif;
}
</style>
<style>
    .contact-us-form .contact-form .form form .form-group textarea.form-control {
        max-height: 100px;
        min-height: 100px;
        min-width: 100%;
        max-width: 100%;
        width: 100% !important;
        height: 100px !important;
        resize: none;
    }
    .contact-us-form .contactformtexttone p{font-size:18px}
</style>



// WEBPACK FOOTER //
// BecomeExpert.vue?01b1e132